import {
    Button,
    Checkbox,
    createStyles,
    FormControlLabel,
    Grid,
    TextField,
    Typography,
    WithStyles,
    withStyles,
} from '@material-ui/core';
import { Add } from '@material-ui/icons';
import * as _ from 'lodash';
import { observer } from 'mobx-react';
import * as React from 'react';
import ESDataTable, { IESDataTableProps } from './ESDataTable';
import ITableOptions from './ITableOptions';

const styles = createStyles({
    gridContainer: {
        paddingBottom: '20px',
        paddingTop: '20px',
    },
    pageContainer: {
        padding: 20,
    },
    searchInput: {
        marginBottom: '15px',
        marginLeft: '20px',
    },
    showInactivesLabel: {
        paddingLeft: '20px',
    },
});

export interface IESDataTableWithHeaderProps {
    enableEdit?: boolean;
    enableSearch?: boolean;
    enableShowInactives?: boolean;
    additionalToggleFilters?: Array<() => JSX.Element>;
    openDialog?: () => void;
    title?: string;
    additionalDropDownFilters?: JSX.Element[];
    rowCellStyleFunction?: (data: any) => React.CSSProperties;
}

@observer
class ESDataTableWithHeader extends React.Component<
    IESDataTableWithHeaderProps & IESDataTableProps & WithStyles<typeof styles>
> {
    public render() {
        const {
            classes,
            dataTableManager,
            enableSearch,
            enableShowInactives,
            additionalToggleFilters,
            openDialog,
            title,
            additionalDropDownFilters,
            rowCellStyleFunction,
            ...rest
        } = this.props;

        const search = enableSearch && (
            <TextField
                className={classes.searchInput}
                label="Search"
                margin="none"
                name="filter"
                onChange={this.onSearchChanged}
                value={dataTableManager.tableOptions.filter}
                style={{ marginRight: '20px' }}
            />
        );
        const showInactives = enableShowInactives && (
            <FormControlLabel
                className={classes.showInactivesLabel}
                control={
                    <Checkbox
                        checked={dataTableManager.tableOptions.includeInactives}
                        color="primary"
                        name="includeInactives"
                        onChange={this.onShowInactivesChanged}
                        value="shouldShowInactives"
                    />
                }
                label="Include Inactives"
            />
        );

        function setupDropDownFilterItems() {
            const dropDownGrid: JSX.Element[] = [];
            if (additionalDropDownFilters != null) {
                additionalDropDownFilters.forEach((element: JSX.Element) => {
                    const filterByItem = <Grid item>{element}</Grid>;
                    dropDownGrid.push(filterByItem);
                });
            }
            return dropDownGrid;
        }

        function setUpToggleFilterItems() {
            const toggleItems: JSX.Element[] = [];
            if (additionalToggleFilters) {
                additionalToggleFilters.forEach((func) => {
                    toggleItems.push(func());
                });
            }
            return toggleItems;
        }

        function setUpNewObjectButton() {
            let button = <div />;
            if (openDialog !== undefined) {
                button = (
                    <Button
                        color="primary"
                        data-cy="action-button"
                        onClick={openDialog}
                        variant="fab"
                    >
                        <Add />
                    </Button>
                );
            }
            return button;
        }

        function setupTitle() {
            let titleName = <div />;
            if (title !== undefined) {
                titleName = <Typography variant="display1">{title}</Typography>;
            }
            return titleName;
        }

        return (
            <Grid className={classes.pageContainer} container direction="column">
                <Grid
                    className={classes.gridContainer}
                    container
                    justify="space-between"
                    wrap="nowrap"
                >
                    <Grid container direction="column">
                        {setupTitle}
                        {search}
                        {showInactives}
                        {setUpToggleFilterItems()}
                    </Grid>
                    <Grid container spacing={16} style={{ marginTop: '1px' }}>
                        <Grid container direction="column">
                            {setupDropDownFilterItems()}
                        </Grid>
                        <Grid container direction="row" justify="flex-end">
                            {setUpNewObjectButton()}
                        </Grid>
                    </Grid>
                </Grid>
                <ESDataTable
                    {...rest}
                    dataTableManager={dataTableManager}
                    rowCellStyleFunction={rowCellStyleFunction}
                />
            </Grid>
        );
    }

    private onSearchChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        this.updateTableOptions({ filter: value, page: 1 });
    };

    private onShowInactivesChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.checked;
        this.updateTableOptions({ includeInactives: value, page: 1 });
    };

    private updateTableOptions = (tableOptions: ITableOptions) => {
        const options = { ...this.props.dataTableManager.tableOptions, ...tableOptions };
        this.props.dataTableManager.updateTableOptions(options);
    };
}

export default withStyles(styles)(ESDataTableWithHeader);



// WEBPACK FOOTER //
// ./src/common/ESDataTableWithHeader.tsx